import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Table,
  Select,
  Modal,
  message,
  Tooltip,
  Tag,
  Icon,
  Input,
  DatePicker,
  Row,
  Col,
  Tabs,
  Descriptions,
  Alert,
  InputNumber,
  Drawer
} from 'antd';
import moment from 'moment';
import {
  constructColumnFilterCheckbox,
  constructColumnFilterRadio,
  constructColumnFilterSearch,
  constructColumn,
  handleOnAggregationTableChange
} from 'utils/table/table';
import {
  getCreateInvoiceList,
  createConsolidatedInvoice,
  getConsolidatedInvoiceList,
  getConsolidatedInvoiceBookings,
  getConsolidatedInvoiceBookingsCsv,
  cancelSubscription,
  activeSubscription,
  manageSubscription,
  loginByAccessToken
} from 'utils/apis/eInvoice';
import { withAppContext } from 'context/AppContext';
import { generateDisplayFee } from 'utils/general';
import { msicCodes } from 'utils/constants';
import { getConstants } from 'utils/apis/constants';
import { CSVLink } from 'react-csv';
import ResubscribeModal from './ResubscribeModal';
import { REACT_APP_E_INVOICE_URL } from 'config/env';

const CompanyProfile = props => {
  const [loading, setLoading] = useState(false);
  const [submittedLoading, setSubmittedLoading] = useState(true);
  const [consolidatedLoading, setConsolidatedLoading] = useState(true);
  const [dateRange, setDateRange] = useState([
    moment()
      .subtract(1, 'month')
      .startOf('month'),
    moment()
      .subtract(1, 'month')
      .endOf('month')
  ]);
  const [submittedDateRange, setSubmittedDateRange] = useState([moment().subtract(1, 'month'), moment()]);
  const [selectRow, setSelectRow] = useState([]);
  const [selectTotalAmount, setSelectTotalAmount] = useState(0);
  const [selectSst, setSelectSst] = useState(0);
  const [selectTtx, setSelectTtx] = useState(0);
  const [targetMonth, setTargetMonth] = useState(null);
  const [targetYear, setTargetYear] = useState(null);

  const [countryOptions, setCountryOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);

  const [summaryVisible, setSummaryVisible] = useState(false);
  const [resubscribeVisible, setResubscribeVisible] = useState(false);
  const [cancelModalVisible, setCancelModalVisible] = useState(false);

  const [createInvoiceData, setCreateInvoiceData] = useState([]);
  const [consolidatedInvoiceData, setConsolidatedInvoiceData] = useState([]);
  const [consolidatedFilters, setConsolidatedFilters] = useState({});
  const [selectedOtas, setSelectedOtas] = useState([]);
  const [bookingsDrawerVisible, setBookingsDrawerVisible] = useState(false);
  const [bookingsDrawerInvoice, setBookingsDrawerInvoice] = useState(null);
  const [bookingsLoading, setBookingsLoading] = useState(false);
  const [bookingsCsvLoading, setBookingsCsvLoading] = useState(false);
  const [bookingsData, setBookingsData] = useState([]);
  const [bookingsPage, setBookingsPage] = useState(1);
  const [bookingsTotal, setBookingsTotal] = useState(0);
  const [bookingsTotalAmount, setBookingsTotalAmount] = useState(0);

  const [csv_data, set_csv_data] = useState([]);
  const [csv_header, set_csv_header] = useState([
    {
      label: 'Creation Date',
      key: 'createdAt'
    },
    {
      label: 'Invoice No.',
      key: 'invoiceNo'
    },
    {
      label: 'Seller Name',
      key: 'sellerName'
    },
    {
      label: 'Currency',
      key: 'currency'
    },
    {
      label: 'Amount',
      key: 'totalPayableAmount'
    },
    {
      label: 'Status',
      key: 'status'
    },
    {
      label: 'LHDN Status',
      key: 'submissionStatus'
    },
    {
      label: 'LHDN Docs UUID',
      key: 'documentUUID'
    },
    {
      label: 'Booking Count',
      key: 'bookingCount'
    }
  ]);

  useEffect(() => {
    // if (props.checkIsAdmin()) {
    GetCreateInvoiceList(props.selectCompanyProfile._id, submittedDateRange);
    GetConsolidatedInvoiceList(props.selectCompanyProfile._id, dateRange);
    // }

    getConstants('countries').then(resCountries => {
      if (resCountries && resCountries.status === 200) {
        let countries = Object.keys(resCountries.data).map(k => {
          return resCountries.data[k];
        });
        if (countries.length > 0) {
          setCountryOptions(
            countries.map(u => {
              return { value: u.iso2, label: u.name };
            })
          );
        }
      } else {
        message.error('Error while retrieving countries');
      }
    });

    getConstants('statesMY').then(resStates => {
      if (resStates && resStates.status === 200) {
        let states = Object.keys(resStates.data).map(k => {
          return resStates.data[k];
        });
        if (states.length > 0) {
          setStateOptions(
            states.map(state => {
              return { value: state.code, label: state.label };
            })
          );
        }
      } else {
        message.error('Error while retrieving states');
      }
    });

    return () => {};
  }, []);

  const GetCreateInvoiceList = async (projectId, selectDate) => {
    setSubmittedLoading(true);
    try {
      const res = await getCreateInvoiceList(projectId, selectDate[0].format('YYYY-MM-DD'), selectDate[1].format('YYYY-MM-DD'));
      console.log('getCreateInvoiceList', res);
      if (res && res.status >= 200 && res.status < 300) {
        setCreateInvoiceData(
          res.data.map(item => ({
            ...item,
            invoiceNo: item.documentNo,
            sellerName: item.sellerId.name
          }))
        );
      } else if (res) {
        message.error((res.data && res.data.message) || 'Failed to load submitted e-Invoices.');
      } else {
        message.error('Failed to load submitted e-Invoices.');
      }
    } finally {
      setSubmittedLoading(false);
    }
  };

  const GetConsolidatedInvoiceList = async (projectId, selectDate) => {
    setConsolidatedLoading(true);
    try {
      const res = await getConsolidatedInvoiceList(projectId, selectDate[0].format('YYYY-MM-DD'), selectDate[1].format('YYYY-MM-DD'), props.hostId);
      console.log('getConsolidatedInvoiceList', res);
      if (res && res.status >= 200 && res.status < 300) {
        setConsolidatedInvoiceData(
          res.data.map(item => ({
            ...item,
            bookingId: item.code,
            platform: (() => {
              switch (item.platform && item.platform.toLowerCase()) {
                case 'hostplatform':
                  return 'Host Platform';
                case 'agoda':
                  return 'Agoda';
                case 'agodahomes':
                  return 'Agoda Homes';
                case 'airbnb':
                  return 'Airbnb';
                case 'bookingcom':
                  return 'Booking.com';
                case 'bookingengine':
                  return 'Booking Engine';
                case 'hotelbookingengine':
                  return 'Hotel Booking Engine';
                case 'ctripcm':
                  return 'Ctrip';
                case 'expedia':
                  return 'Expedia';
                case 'extintegration':
                  return 'Ext Integration';
                case 'traveloka':
                  return 'Traveloka';
                case 'tiketcom':
                  return 'Tiket.com';
                default:
                  return 'Host Platform';
              }
            })(),
            logo: (() => {
              switch (item.platform && item.platform.toLowerCase()) {
                case 'hostplatform':
                  return require('../../../images/hostplatform-logo.png');
                case 'agoda':
                  return require('../../../images/agoda-logo-icon.png');
                case 'agodahomes':
                  return require('../../../images/agodahomes-logo-icon-1.png');
                case 'airbnb':
                  return require('../../../images/airbnb-logo-1.png');
                case 'bookingcom':
                  return require('../../../images/booking-logo.png');
                case 'bookingengine':
                  return require('../../../images/booking-logo-icon-1.webp');
                case 'hotelbookingengine':
                  return require('../../../images/booking-logo-icon-1.webp');
                case 'ctripcm':
                  return require('../../../images/ctrip-logo-1.jpg');
                case 'expedia':
                  return require('../../../images/expedia.svg');
                case 'extintegration':
                  return require('../../../images/extIntegration-logo-icon.png');
                case 'traveloka':
                  return require('../../../images/traveloka-logo-icon-1.png');
                case 'tiketcom':
                  return require('../../../images/tiketcom-logo-icon-1.png');
                default:
                  return require('../../../images/hostplatform-logo.png');
                // return require('../../../images/others-logo-icon.png');
              }
            })()
          }))
        );
      } else if (res) {
        message.error((res.data && res.data.message) || 'Failed to load reservations for consolidated e-Invoice.');
      } else {
        message.error('Failed to load reservations for consolidated e-Invoice.');
      }
    } finally {
      setConsolidatedLoading(false);
    }
  };

  const monthOptions = moment.months(); // January ... December
  const yearOptions = [moment().year(), moment().year() - 1];

  const handleCreateConsolidatedInvoice = async () => {
    setLoading(true);
    try {
      const exclusiveAmount = Number(Number(selectTotalAmount || 0).toFixed(2));
      const sstAmount = Number(Number(selectSst || 0).toFixed(2));
      const ttxAmount = Number(Number(selectTtx || 0).toFixed(2));
      const res = await createConsolidatedInvoice({
        projectId: props.selectCompanyProfile._id,
        bookingDetails: selectRow.map(item => ({
          ota: item.source,
          bookingID: item.bookingId,
          amount: Number(Number(item.amount || 0).toFixed(2)),
          reservationId: item._id,
          platform: item.platform,
          startDate: item.startDate,
          endDate: item.endDate,
          host: item.host,
          property: item.property,
          bookingStatus: item.bookingStatus
        })),
        totalAmount: exclusiveAmount,
        totalSalesTax: sstAmount,
        totalTourismTax: ttxAmount,
        totalPayableAmount: Number((exclusiveAmount + sstAmount + ttxAmount).toFixed(2)),
        targetMonth: `${targetMonth} ${targetYear}`
      });
      if (res && res.status >= 200 && res.status < 300) {
        Modal.success({
          title: 'Consolidated e-Invoice created successfully!',
          onOk() {
            window.location.reload();
          }
        });
        return;
      }
      const errorMessage =
        (res && res.data && res.data.message) || (res && typeof res.data === 'string' && res.data) || 'Failed to create consolidated e-Invoice.';
      message.error(errorMessage);
    } catch (error) {
      message.error('Failed to create consolidated e-Invoice.');
    } finally {
      setLoading(false);
    }
  };

  const GetInvoiceBookings = async (invoice, page = 1) => {
    setBookingsLoading(true);
    try {
      const res = await getConsolidatedInvoiceBookings(invoice._id, {
        page,
        limit: 50,
        hostId: props.hostId
      });
      if (res && res.status >= 200 && res.status < 300) {
        setBookingsData(
          (res.data.bookings || []).map(item => ({
            ...item,
            _id: item.reservationId,
            bookingId: item.bookingID,
            source: item.ota,
            platform: (() => {
              switch ((item.ota || item.platform || '').toLowerCase()) {
                case 'hostplatform':
                  return 'Host Platform';
                case 'agoda':
                  return 'Agoda';
                case 'agodahomes':
                  return 'Agoda Homes';
                case 'airbnb':
                  return 'Airbnb';
                case 'bookingcom':
                  return 'Booking.com';
                case 'bookingengine':
                  return 'Booking Engine';
                case 'hotelbookingengine':
                  return 'Hotel Booking Engine';
                case 'ctripcm':
                  return 'Ctrip';
                case 'expedia':
                  return 'Expedia';
                case 'extintegration':
                  return 'Ext Integration';
                case 'traveloka':
                  return 'Traveloka';
                case 'tiketcom':
                  return 'Tiket.com';
                default:
                  return item.platform || item.ota || 'Host Platform';
              }
            })(),
            logo: (() => {
              switch ((item.ota || item.platform || '').toLowerCase()) {
                case 'hostplatform':
                  return require('../../../images/hostplatform-logo.png');
                case 'agoda':
                  return require('../../../images/agoda-logo-icon.png');
                case 'agodahomes':
                  return require('../../../images/agodahomes-logo-icon-1.png');
                case 'airbnb':
                  return require('../../../images/airbnb-logo-1.png');
                case 'bookingcom':
                  return require('../../../images/booking-logo.png');
                case 'bookingengine':
                  return require('../../../images/booking-logo-icon-1.webp');
                case 'hotelbookingengine':
                  return require('../../../images/booking-logo-icon-1.webp');
                case 'ctripcm':
                  return require('../../../images/ctrip-logo-1.jpg');
                case 'expedia':
                  return require('../../../images/expedia.svg');
                case 'extintegration':
                  return require('../../../images/extIntegration-logo-icon.png');
                case 'traveloka':
                  return require('../../../images/traveloka-logo-icon-1.png');
                case 'tiketcom':
                  return require('../../../images/tiketcom-logo-icon-1.png');
                default:
                  return require('../../../images/hostplatform-logo.png');
              }
            })()
          }))
        );
        setBookingsPage(res.data.page || page);
        setBookingsTotal(res.data.bookingCount || 0);
        setBookingsTotalAmount(res.data.totalPayableAmount || invoice.totalPayableAmount || 0);
      } else if (res) {
        message.error((res.data && res.data.message) || 'Failed to load reservations.');
      } else {
        message.error('Failed to load reservations.');
      }
    } finally {
      setBookingsLoading(false);
    }
  };

  const handleOpenBookingsDrawer = invoice => {
    setBookingsDrawerInvoice(invoice);
    setBookingsDrawerVisible(true);
    setBookingsData([]);
    setBookingsPage(1);
    setBookingsTotal(invoice.bookingCount || 0);
    setBookingsTotalAmount(invoice.totalPayableAmount || 0);
    GetInvoiceBookings(invoice, 1);
  };

  const handleDownloadBookingsCsv = async () => {
    if (!bookingsDrawerInvoice) {
      return;
    }
    setBookingsCsvLoading(true);
    try {
      const res = await getConsolidatedInvoiceBookingsCsv(bookingsDrawerInvoice._id, props.hostId);
      if (res && res.status >= 200 && res.status < 300) {
        const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${String(bookingsDrawerInvoice.documentNo || 'invoice').replace(/[^a-z0-9.-]/gi, '_')}_reservations.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        message.error('Failed to export reservations CSV.');
      }
    } catch (error) {
      message.error('Failed to export reservations CSV.');
    } finally {
      setBookingsCsvLoading(false);
    }
  };

  const handleCancelSubscription = async () => {
    setLoading(true);
    const res = await cancelSubscription(props.selectCompanyProfile._id);
    setLoading(false);
    setCancelModalVisible(false);

    if (res.status >= 200 && res.status < 300) {
      Modal.success({
        title: 'Subscription cancelled successfully!',
        onOk() {
          window.location.reload();
        }
      });
    }
  };

  const formatOrderRenewalLabel = endDate =>
    endDate
      ? moment
          .unix(endDate)
          .utcOffset(8)
          .format('DD/MM/YYYY hh:mm A')
      : '—';

  const orderCurrency =
    (props.selectCompanyProfile.order.defaultCurrency || 'MYR') === 'RM' ? 'MYR' : props.selectCompanyProfile.order.defaultCurrency || 'MYR';
  const orderAmount = props.selectCompanyProfile.order.amount;
  const nextChargeAmount =
    orderAmount == null || !Number.isFinite(Number(orderAmount)) ? `${orderCurrency} —` : `${orderCurrency} ${Number(orderAmount).toFixed(2)}`;

  const handleActiveSubscription = async () => {
    setLoading(true);
    const res = await activeSubscription(props.selectCompanyProfile._id);
    console.log('res', res);
    setLoading(false);

    if (res.status >= 200 && res.status < 300) {
      Modal.success({
        title: 'Subscription activated successfully!',
        onOk() {
          window.location.reload();
        }
      });
    }
  };

  const handleManageSubscription = async () => {
    setLoading(true);
    const res = await manageSubscription({
      projectId: props.selectCompanyProfile.order.projectId,
      customerId: props.selectCompanyProfile.order.customerId
    });
    console.log('res', res);
    setLoading(false);

    if (res.status >= 200 && res.status < 300) {
      window.location.href = res.data.redirectUrl;
    }
  };

  const generateCSV = () => {
    // if (allList.isLoading === true) {
    //   return;
    // }

    var order = [...createInvoiceData];
    // var order = [...allList.paginatedData];
    var csv_data = [];
    // var sum_balance = 0;

    for (let i = 0; i < order.length; i++) {
      const real_order = order[i];
      // console.log(real_order);
      // sum_balance = parseFloat(
      //   parseFloat(sum_balance + real_order.balance).toFixed(2)
      // );

      csv_data.push({
        createdAt: moment(real_order.createdAt).format('YYYY-MM-DD HH:mm:ss'),
        invoiceNo: real_order.invoiceNo,
        sellerName: real_order.sellerName,
        currency: real_order.currency,
        totalPayableAmount: real_order.totalPayableAmount,
        status: real_order.status,
        submissionStatus: real_order.submissionStatus,
        documentUUID: real_order.documentUUID,
        bookingCount: real_order.bookingCount || 0
      });
    }
    // csv_data.push({
    //   balance: sum_balance,
    // });
    set_csv_data(csv_data);
    // this.setState({
    //   csv_data,
    // });
    return true;
  };

  const columns = [
    {
      ...constructColumn('Created At', 'createdAt', {
        hasSorter: true
      }),
      render: (value, record) => {
        return moment(value).format('YYYY-MM-DD HH:mm:ss');
      }
    },
    {
      ...constructColumn('Invoice No.', 'invoiceNo'),
      ...constructColumnFilterSearch('invoiceNo', 'Search Invoice No.')
    },
    {
      ...constructColumn('Seller Name', 'sellerName'),
      ...constructColumnFilterSearch('sellerName', 'Search Seller Name')
    },
    {
      ...constructColumn('Currency', 'currency')
      // render: (value, record) => {
      //   return `${
      //     currencyConstant.find((c) => c.code === value)?.code
      //   } - Ex Rate ${Number(record.currencyExRate).toFixed(5)}`;
      // },
    },
    {
      ...constructColumn('Amount', 'totalPayableAmount', {
        hasSorter: true
      }),
      render: (value, record) => {
        return generateDisplayFee(value);
      }
    },
    {
      ...constructColumn('Status', 'status'),
      // ...getColumnFilterSearchProps("type", "Search Type"),
      filterMultiple: false,
      filters: [
        {
          text: <Tag color="blue">Queuing</Tag>,
          value: 'queuing'
        },
        {
          text: <Tag color="blue">Processing</Tag>,
          value: 'processing'
        },
        {
          text: <Tag color="blue">Submitting To LHDN</Tag>,
          value: 'submittingToLHDN'
        },
        {
          text: <Tag color="green">Completed</Tag>,
          value: 'completed'
        },
        {
          text: <Tag color="orange">Waiting Customer Fill Form</Tag>,
          value: 'waitingCustomerFillForm'
        },
        {
          text: <Tag color="orange">Customer Form Expired</Tag>,
          value: 'customerFormExpired'
        },
        {
          //missing
          text: <Tag color="orange">Missing Fields</Tag>,
          value: 'missingFields'
        },
        {
          //missing buyer
          text: <Tag color="orange">Incomplete Buyer Details</Tag>,
          value: 'incompleteBuyerDetails'
        },
        {
          //missing seller
          text: <Tag color="orange">Incomplete Seller Details</Tag>,
          value: 'incompleteSellerDetails'
        },
        {
          //missing shipping
          text: <Tag color="orange">Incomplete Shipping Receipient Details</Tag>,
          value: 'incompleteShippingReceipientDetails'
        }
      ],
      onFilter: (value, record) => {
        // console.log(value, record);
        return value === record.status;
      },
      render: (value, record) => {
        var status = value;

        switch (status) {
          case 'queuing':
            return <Tag color="blue">Queuing</Tag>;

          case 'processing':
            return <Tag color="blue">Processing</Tag>;

          case 'submittingToLHDN':
            return <Tag color="blue">Submitting To LHDN</Tag>;

          case 'completed':
            return <Tag color="green">Completed</Tag>;

          case 'missingFields':
            return (
              <Tooltip title={record.errorMessage}>
                <Tag color="orange">
                  <Icon type="question-circle" /> Missing Fields
                </Tag>
              </Tooltip>
            );

          case 'incompleteBuyerDetails':
            return (
              <Tooltip title={record.errorMessage}>
                <Tag color="orange">
                  <Icon type="question-circle" /> Incomplete Buyer Details
                </Tag>
              </Tooltip>
            );

          case 'incompleteSellerDetails':
            return (
              <Tooltip title={record.errorMessage}>
                <Tag color="orange">
                  <Icon type="question-circle" /> Incomplete Seller Details
                </Tag>
              </Tooltip>
            );

          case 'incompleteShippingReceipientDetails':
            return (
              <Tooltip title={record.errorMessage}>
                <Tag color="orange">
                  <Icon type="question-circle" /> Incomplete Shipping Receipient Details
                </Tag>
              </Tooltip>
            );

          case 'waitingCustomerFillForm':
            return (
              <>
                <Tag color="orange">Waiting Customer Fill Form</Tag>
                <a
                  href={`${REACT_APP_E_INVOICE_URL}/customer-self-service-form?invoiceId=${record._id}&projectId=${record.projectId._id}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Icon type="link" /> Link
                </a>
              </>
            );

          case 'customerFormExpired':
            return (
              <Tooltip title={'Customer form only valid for 24 hours upon creation.'}>
                <>
                  <Tag color="orange">
                    <Icon type="question-circle" /> Customer Form Expired
                  </Tag>
                </>
              </Tooltip>
            );

          case 'rejected':
            return <Tag color="red">Rejected</Tag>;

          case 'retrySubmission':
            return <Tag color="orange">Retry Submission</Tag>;

          case 'missingFields':
            return <Tag color="purple">Missing Fields</Tag>;

          case 'submittingToLHDN':
            return <Tag color="gold">Submit to LHDN</Tag>;

          case 'error':
            return (
              <Tooltip title={record.errorMessage}>
                <Tag color="red">
                  <Icon type="question-circle" />
                  Error
                </Tag>
              </Tooltip>
            );

          default:
            return <Tag color="orange">{status}</Tag>;
        }
      }
    },

    {
      ...constructColumn('LHDN Status', 'submissionStatus'),
      // ...getColumnFilterSearchProps("submissionStatus", "Search Status"),
      filterMultiple: false,
      filters: [
        {
          text: <Tag>N/A</Tag>,
          value: 'N/A'
        },
        {
          text: <Tag color="blue">In Progress</Tag>,
          value: 'InProgress'
        },
        {
          text: <Tag color="blue">Retrying Submission</Tag>,
          value: 'Retry'
        },
        {
          text: <Tag color="green">Valid</Tag>,
          value: 'Valid'
        },
        {
          text: <Tag color="red">Invalid</Tag>,
          value: 'Invalid'
        },
        {
          text: <Tag color="orange">Cancelled</Tag>,
          value: 'Cancelled'
        },
        {
          text: <Tag color="orange">Missing API Key Set</Tag>,
          value: 'missingAPIKeySet'
        },
        {
          text: <Tag color="orange">Invalid API Key Set</Tag>,
          value: 'invalidAPIKeySet'
        },
        {
          text: <Tag color="red">Rejected</Tag>,
          value: 'Rejected'
        },
        {
          text: <Tag color="red">Invoice Rejected by Buyer</Tag>,
          value: 'InvoiceRejectedByBuyer'
        },
        {
          text: <Tag color="green">Submitted</Tag>,
          value: 'Submitted'
        }
      ],
      onFilter: (value, record) => {
        // console.log(value, record);
        return value === record.submissionStatus;
      },
      render: (value, record) => {
        switch (value) {
          case 'N/A':
            return <Tag>N/A</Tag>;

          case 'InProgress':
            return <Tag color="blue">In Progress</Tag>;

          case 'Retry':
            return <Tag color="blue">Retrying Submission</Tag>;

          case 'Valid':
            return <Tag color="green">Valid</Tag>;

          case 'Invalid':
            return (
              <Tooltip title={record.errorMessage}>
                <Tag color="red">
                  <Icon type="question-circle" /> Invalid
                </Tag>
              </Tooltip>
            );

          case 'Cancelled':
            return (
              <Tooltip title={`Reason : ${record.cancellationReason}`}>
                <Tag color="orange">
                  <Icon type="question-circle" /> Cancelled
                </Tag>
              </Tooltip>
            );

          case 'missingAPIKeySet':
            return (
              // <Tooltip
              //   title={
              //     <>
              //       <a
              //         onClick={() => {
              //           props.handleMenu({
              //             key: '5'
              //           });
              //         }}
              //       >
              //         Configure API Key.
              //       </a>
              //       <br />
              //       System will automatically resume the submission once the key is set.
              //     </>
              //   }
              // >
              <Tag color="orange">
                <Icon type="question-circle" /> Missing API Key Set
              </Tag>
              // </Tooltip>
            );

          case 'invalidAPIKeySet':
            return (
              // <Tooltip
              //   title={
              //     <>
              //       <a
              //         onClick={() => {
              //           props.handleMenu({
              //             key: '5'
              //           });
              //         }}
              //       >
              //         Configure API Key.
              //       </a>
              //       <br />
              //       API key is invalid. Please check the key and try again.
              //     </>
              //   }
              // >
              <Tag color="orange">
                <Icon type="question-circle" /> Invalid API Key Set
              </Tag>
              // </Tooltip>
            );

          case 'Rejected':
            return (
              <Tooltip title={record.errorMessage}>
                <Tag color="red">
                  <Icon type="question-circle" /> Rejected
                </Tag>
              </Tooltip>
            );

          case 'InvoiceRejectedByBuyer':
            return (
              <Tooltip title={record.errorMessage}>
                <Tag color="red">
                  <Icon type="question-circle" /> Invoice Rejected by Buyer
                </Tag>
              </Tooltip>
            );

          case 'Submitted':
            return <Tag color="green">Submitted</Tag>;

          case 'Error':
            return (
              <Tooltip title={record.errorMessage}>
                <Tag color="red">
                  <Icon type="question-circle" /> Error
                </Tag>
              </Tooltip>
            );
          default:
            return <Tag>{value}</Tag>;
        }
      }
    },
    {
      ...constructColumn('LHDN Docs UUID', 'documentUUID'),
      ...constructColumnFilterSearch('documentUUID', 'Search LHDN docs UUID')
    },
    {
      ...constructColumn('Booking Count', 'bookingCount', {
        hasSorter: true
      }),
      render: (value, record) => {
        return value || 0;
      }
    },
    {
      ...constructColumn('Actions', ''),
      render: (value, record) => {
        const sanitizedFileName = record.documentNo.replace(/[^a-z0-9]/gi, '_').toLowerCase();

        const filenameSummary = `${sanitizedFileName}_${record.documentUUID}_summary.pdf`.toLowerCase();
        const filenameDetails = `${sanitizedFileName}_${record.documentUUID}_details.pdf`.toLowerCase();
        return (
          <div>
            <Row>
              <Col>
                <Button type="link" disabled={!record.bookingCount} onClick={() => handleOpenBookingsDrawer(record)}>
                  View Reservations
                </Button>
              </Col>
              <Col>
                <Button
                  type="link"
                  disabled={record.submissionStatus !== 'Valid'}
                  target="_blank"
                  onClick={async () => {
                    try {
                      const result = await loginByAccessToken();
                      if (result.success) {
                        window.open(`${REACT_APP_E_INVOICE_URL}/api/data/${filenameSummary}?access_token=${result.data.token}`, '_blank');
                      } else {
                        message.error(result.message || 'Failed to get access token');
                      }
                    } catch (error) {
                      message.error('An error occurred while trying to view the invoice');
                      console.error('Invoice view error:', error);
                    }
                  }}
                >
                  <Icon type="cloud-download" /> Download Summary
                </Button>
              </Col>
              <Col>
                <Button
                  type="link"
                  disabled={record.submissionStatus !== 'Valid'}
                  target="_blank"
                  onClick={async () => {
                    try {
                      const result = await loginByAccessToken();
                      if (result.success) {
                        window.open(`${REACT_APP_E_INVOICE_URL}/api/data/${filenameDetails}?access_token=${result.data.token}`, '_blank');
                      } else {
                        message.error(result.message || 'Failed to get access token');
                      }
                    } catch (error) {
                      message.error('An error occurred while trying to view the invoice');
                      console.error('Invoice view error:', error);
                    }
                  }}
                >
                  <Icon type="cloud-download" /> Download Details
                </Button>
              </Col>
            </Row>
          </div>
        );
      }
    }
  ];

  const columnsInvoice = [
    // {
    //   ...constructColumn('Created At', 'createdAt', {
    //     hasSorter: true
    //   }),
    //   render: (value, record) => {
    //     return moment(value).format('YYYY-MM-DD HH:mm:ss');
    //   }
    // },
    {
      ...constructColumn('Start Date', 'startDate', {
        hasSorter: true
      }),
      render: (value, record) => {
        return moment(value).format('YYYY-MM-DD');
      }
    },
    {
      ...constructColumn('End Date', 'endDate', {
        hasSorter: true
      }),
      render: (value, record) => {
        return moment(value).format('YYYY-MM-DD');
      }
    },
    {
      ...constructColumn('OTA', 'logo'),
      render: (value, record) => {
        return <img src={value} alt="logo" style={{ width: record.platform === 'extintegration' ? 50 : 100 }} />;
      }
    },
    {
      ...constructColumn('Host Name', 'host'),
      ...constructColumnFilterSearch('host', 'Search Host Name')
    },
    {
      ...constructColumn('Property', 'property'),
      ...constructColumnFilterSearch('property', 'Search Property')
    },
    {
      ...constructColumn('OTA', 'platform'),
      ...constructColumnFilterSearch('platform', 'Search OTA'),
      render: (value, record) => {
        if (value) {
          return value;
        }
      }
    },
    {
      ...constructColumn('Booking ID', 'bookingId'),
      ...constructColumnFilterSearch('bookingId', 'Search Booking ID'),
      render: (value, record) => {
        const url = new URL(window.location.href);
        const id = url.searchParams.get('_id');

        return (
          <a href={`/reservation/${record._id}/edit?_id=${id}`} target="_blank" rel="noopener noreferrer">
            {value}
          </a>
        );
      }
    },
    {
      ...constructColumn('Booking Status', 'bookingStatus'),
      filterMultiple: true,
      filters: [
        {
          text: <Tag color="blue">Reserved</Tag>,
          value: 'Reserved'
        },
        {
          text: <Tag color="green">Confirmed</Tag>,
          value: 'Confirmed'
        },
        {
          text: <Tag color="orange">Awaiting Payment</Tag>,
          value: 'Awaiting Payment'
        },
        {
          text: <Tag color="orange">Checked-in</Tag>,
          value: 'checkin'
        },
        {
          text: <Tag color="orange">Checked-out</Tag>,
          value: 'checkout'
        },
        {
          text: <Tag color="orange">Cancelled</Tag>,
          value: 'Cancelled by Host'
        },
        {
          text: <Tag color="orange">Cancelled by Guest</Tag>,
          value: 'Cancelled by Guest'
        },
        {
          text: <Tag color="orange">Cancelled by OTA</Tag>,
          value: 'Cancelled by OTA'
        },
        {
          text: <Tag color="orange">No Show</Tag>,
          value: 'No Show'
        },
        {
          text: <Tag color="orange">Vacant Dirty (VD)</Tag>,
          value: 'vacantDirty'
        },
        {
          text: <Tag color="orange">Vacant Clean (VC)</Tag>,
          value: 'vacantClean'
        }
      ],
      onFilter: (value, record) => {
        // console.log(value, record);
        return value === record.bookingStatus;
      },
      render: (value, record) => {
        switch (value) {
          case 'Reserved':
            return <Tag color="blue">Reserved</Tag>;

          case 'Confirmed':
            return <Tag color="green">Confirmed</Tag>;

          case 'Awaiting Payment':
            return <Tag color="orange">Awaiting Payment</Tag>;

          case 'checkin':
            return <Tag color="orange">Checked-in</Tag>;

          case 'checkout':
            return <Tag color="orange">Checked-out</Tag>;

          case 'Cancelled by Host':
            return <Tag color="orange">Cancelled by Host</Tag>;

          case 'Cancelled by Guest':
            return <Tag color="orange">Cancelled by Guest</Tag>;

          case 'Cancelled by OTA':
            return <Tag color="orange">Cancelled by OTA</Tag>;

          case 'No Show':
            return <Tag color="orange">No Show</Tag>;

          case 'vacantDirty':
            return <Tag color="orange">Vacant Dirty (VD)</Tag>;

          case 'vacantClean':
            return <Tag color="orange">Vacant Clean (VC)</Tag>;

          default:
            return '-';
        }
      }
    },
    {
      ...constructColumn('Amount', 'amount', {
        hasSorter: true
      }),
      render: (value, record) => {
        return generateDisplayFee(value);
      }
    }
  ];

  // Apply Ant Design column filters to a dataset (used so Select All / Next respect table filters)
  const applyConsolidatedFilters = (data, filters = consolidatedFilters) => {
    if (!filters || !columnsInvoice) {
      return data;
    }
    return data.filter(record =>
      columnsInvoice.every(col => {
        const key = col.key || col.dataIndex;
        const filterValues = filters[key];
        if (!filterValues || filterValues.length === 0 || typeof col.onFilter !== 'function') {
          return true;
        }
        // Within a column, a row matches if any selected filter value matches (OR)
        return filterValues.some(value => col.onFilter(value, record));
      })
    );
  };

  const otaOptions = useMemo(() => {
    return [...new Set(consolidatedInvoiceData.map(item => item.platform).filter(Boolean))].sort();
  }, [consolidatedInvoiceData]);

  const otaFilteredData = useMemo(() => {
    if (!selectedOtas.length) {
      return consolidatedInvoiceData;
    }
    return consolidatedInvoiceData.filter(item => selectedOtas.includes(item.platform));
  }, [consolidatedInvoiceData, selectedOtas]);

  // Select all applies to the full filtered list, not just the current page
  const rowSelection = {
    selectedRowKeys: selectRow.map(item => String(item._id)),
    onSelect: (record, selected) => {
      setSelectRow(prev =>
        selected
          ? [...prev.filter(row => String(row._id) !== String(record._id)), record]
          : prev.filter(row => String(row._id) !== String(record._id))
      );
    },
    onSelectAll: selected => {
      if (!selected) {
        setSelectRow([]);
        return;
      }
      setSelectRow(applyConsolidatedFilters(otaFilteredData));
    }
  };

  const CompanyProfileDetails = (
    <>
      <Descriptions bordered layout="vertical" title="Subscription Information" style={{ marginBottom: 40 }}>
        <Descriptions.Item label={<span style={{ fontWeight: 600 }}>Plan</span>}>{props.selectCompanyProfile.plan}</Descriptions.Item>
        <Descriptions.Item label={<span style={{ fontWeight: 600 }}>Status</span>}>
          {(() => {
            const status = props.selectCompanyProfile.order.subscriptionStatus;
            const cancelAtEnd = props.selectCompanyProfile.order.cancelAtEndDate;
            if ((status === 'active' || status === 'trialing' || status === 'complete') && cancelAtEnd) {
              return <Tag color="orange">Cancelled</Tag>;
            }
            if (status === 'active' || status === 'trialing' || status === 'complete') {
              return <Tag color="green">Active</Tag>;
            }
            if (status === 'past_due') {
              return <Tag color="red">Past Due</Tag>;
            }
            if (status === 'canceled') {
              return <Tag color="red">Expired</Tag>;
            }
            return <Tag>{status || '-'}</Tag>;
          })()}
        </Descriptions.Item>
        <Descriptions.Item label={<span style={{ fontWeight: 600 }}>Renewal Date</span>}>
          {props.selectCompanyProfile.order.subscriptionStatus === 'active' ||
          props.selectCompanyProfile.order.subscriptionStatus === 'trialing' ||
          props.selectCompanyProfile.order.subscriptionStatus === 'complete'
            ? moment
                .unix(props.selectCompanyProfile.order.endDate)
                .utcOffset(8)
                .format('DD/MM/YYYY hh:mm A') +
              ' (' +
              (moment
                .unix(props.selectCompanyProfile.order.endDate)
                .utcOffset(8)
                .startOf('day')
                .diff(
                  moment
                    .unix(props.selectCompanyProfile.order.startDate)
                    .utcOffset(8)
                    .startOf('day'),
                  'days'
                ) > 60
                ? 'Yearly'
                : 'Monthly') +
              ')'
            : 'Subscription Expired'}
        </Descriptions.Item>
        <Descriptions.Item label={<span style={{ fontWeight: 600 }}>Current Period</span>}>
          {props.selectCompanyProfile.order.startDate && props.selectCompanyProfile.order.endDate
            ? `${moment.unix(props.selectCompanyProfile.order.startDate).format('DD/MM/YYYY')} – ${moment
                .unix(props.selectCompanyProfile.order.endDate)
                .format('DD/MM/YYYY')}`
            : '-'}
        </Descriptions.Item>
        <Descriptions.Item label={<span style={{ fontWeight: 600 }}>e-Invoice Balance</span>}>
          {Number(props.selectCompanyProfile.order.eInvoiceCount) >= 999999999999
            ? 'Unlimited'
            : `${props.selectCompanyProfile.order.eInvoiceBalance} / ${props.selectCompanyProfile.order.eInvoiceCount}`}
        </Descriptions.Item>
        <Descriptions.Item label={<span style={{ fontWeight: 600 }}>Subscribed Since</span>}>
          {props.selectCompanyProfile.order.createdAt ? moment(props.selectCompanyProfile.order.createdAt).format('DD/MM/YYYY') : '-'}
        </Descriptions.Item>
      </Descriptions>

      <Descriptions bordered layout="vertical" title="Company Profile" style={{ marginBottom: 40 }}>
        <Descriptions.Item label={<span style={{ fontWeight: 600 }}>Icon</span>}>
          <img src={props.selectCompanyProfile.icon.url} alt="icon" style={{ width: 200 }} />
        </Descriptions.Item>

        <Descriptions.Item label={<span style={{ fontWeight: 600 }}>Name</span>}>{props.selectCompanyProfile.name}</Descriptions.Item>

        <Descriptions.Item label={<span style={{ fontWeight: 600 }}>BRN</span>}>{props.selectCompanyProfile.brn}</Descriptions.Item>

        <Descriptions.Item label={<span style={{ fontWeight: 600 }}>TIN</span>}>{props.selectCompanyProfile.tinNumber}</Descriptions.Item>
        <Descriptions.Item label={<span style={{ fontWeight: 600 }}>Tourism Tax Registration Number</span>}>
          {props.selectCompanyProfile.tourismTaxRegistrationNumber || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={<span style={{ fontWeight: 600 }}>SST Registration Number</span>}>
          {props.selectCompanyProfile.sstRegistrationNumber || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={<span style={{ fontWeight: 600 }}>Address</span>}>
          {props.selectCompanyProfile.companyAddress1 +
            (!props.selectCompanyProfile.companyAddress2 || props.selectCompanyProfile.companyAddress2 === 'undefined'
              ? ''
              : ', ' + props.selectCompanyProfile.companyAddress2) +
            (!props.selectCompanyProfile.companyAddress3 || props.selectCompanyProfile.companyAddress3 === 'undefined'
              ? ''
              : ', ' + props.selectCompanyProfile.companyAddress3)}
        </Descriptions.Item>

        <Descriptions.Item label={<span style={{ fontWeight: 600 }}>City</span>}>{props.selectCompanyProfile.city}</Descriptions.Item>
        <Descriptions.Item label={<span style={{ fontWeight: 600 }}>Country</span>}>
          {(countryOptions.find(c => c.value === props.selectCompanyProfile.country) || {}).label || props.selectCompanyProfile.country}
        </Descriptions.Item>
        <Descriptions.Item label={<span style={{ fontWeight: 600 }}>State</span>}>
          {(stateOptions.find(s => s.value === props.selectCompanyProfile.state) || {}).label || props.selectCompanyProfile.state}
        </Descriptions.Item>
        <Descriptions.Item label={<span style={{ fontWeight: 600 }}>Postal Code</span>}>{props.selectCompanyProfile.postalCode}</Descriptions.Item>

        <Descriptions.Item label={<span style={{ fontWeight: 600 }}>Email</span>}>{props.selectCompanyProfile.email}</Descriptions.Item>

        <Descriptions.Item label={<span style={{ fontWeight: 600 }}>Contact</span>}>{props.selectCompanyProfile.contact}</Descriptions.Item>
        <Descriptions.Item label={<span style={{ fontWeight: 600 }}>MSIC Code</span>}>
          {props.selectCompanyProfile.msicCode} - {(msicCodes.find(m => m.code === props.selectCompanyProfile.msicCode) || {}).label}
        </Descriptions.Item>

        <Descriptions.Item label={<span style={{ fontWeight: 600 }}>Business Activity Description</span>}>
          {props.selectCompanyProfile.businessActivityDescription}
        </Descriptions.Item>
        {/* <Descriptions.Item label="Status">
        <Tag color={props.selectCompanyProfile.status === 'Active' ? 'green' : 'red'}>{props.selectCompanyProfile.status}</Tag>
      </Descriptions.Item> */}
      </Descriptions>
    </>
  );

  const eInvoiceTabs = (
    <Tabs defaultActiveKey="1">
      <Tabs.TabPane tab="Submitted e-Invoice" key="1">
        <Row type="flex" justify="end" align="middle" gutter={16} style={{ marginBottom: 16 }}>
          <Col>
            <CSVLink
              data={csv_data}
              headers={csv_header}
              filename={`${moment(submittedDateRange[0]).format('YYYY-MM-DD')}_${moment(submittedDateRange[1]).format(
                'YYYY-MM-DD'
              )}_e-invoice_submitted.csv`}
              onClick={generateCSV}
            >
              <Button
                id="configure-button"
                type="primary"
                // style={{ marginLeft: 'auto', marginRight: '8px' }}
                icon="cloud-download"
                onClick={() => {
                  return;
                }}
                disabled={submittedLoading || loading}
              >
                Export CSV
              </Button>
            </CSVLink>
          </Col>

          <Col>
            <Row type="flex" justify="end" align="middle">
              <Col style={{ marginRight: 8 }}>Date Range :</Col>
              <DatePicker.RangePicker
                allowClear={false}
                value={submittedDateRange}
                format="YYYY-MM-DD"
                disabled={submittedLoading}
                onChange={(date, dateString) => {
                  setSubmittedDateRange(date);
                  GetCreateInvoiceList(props.selectCompanyProfile._id, date);
                }}
              />
            </Row>
          </Col>
        </Row>

        <Table loading={submittedLoading} rowKey={record => record._id} columns={columns} dataSource={createInvoiceData} scroll={{ x: true }} />
      </Tabs.TabPane>

      <Tabs.TabPane tab="Create Consolidated e-Invoice" key="2">
        <div style={{ marginBottom: 16 }}>
          <Alert
            showIcon
            type="info"
            message={
              <>
                Reservations below are retrieved based on the check-out date for consolidated e-Invoice submission.
                <br />
                Both parent and child listings will be displayed. Please filter and select the reservations for e-Invoice submission carefully.
              </>
            }
          />
        </div>

        <Row type="flex" justify="space-between" align="middle" gutter={8} style={{ marginBottom: 16 }}>
          <Col>
            <Select
              mode="multiple"
              allowClear
              placeholder="Select OTA"
              value={selectedOtas}
              style={{ minWidth: 240 }}
              disabled={consolidatedLoading}
              onChange={values => {
                const nextOtas = values || [];
                setSelectedOtas(nextOtas);
                const visibleRows = !nextOtas.length
                  ? consolidatedInvoiceData
                  : consolidatedInvoiceData.filter(item => nextOtas.includes(item.platform));
                const visibleIds = new Set(visibleRows.map(row => String(row._id)));
                setSelectRow(prev => prev.filter(row => visibleIds.has(String(row._id))));
              }}
            >
              {otaOptions.map(ota => (
                <Select.Option key={ota} value={ota}>
                  {ota}
                </Select.Option>
              ))}
            </Select>
          </Col>

          <Col>
            <Row type="flex" align="middle" gutter={8}>
              <Col>Date Range :</Col>
              <Col>
                <DatePicker.RangePicker
                  allowClear={false}
                  value={dateRange}
                  format="YYYY-MM-DD"
                  disabled={consolidatedLoading}
                  onChange={(date, dateString) => {
                    setDateRange(date);
                    setSelectRow([]);
                    setConsolidatedFilters({});
                    setSelectedOtas([]);
                    GetConsolidatedInvoiceList(props.selectCompanyProfile._id, date);
                  }}
                />
              </Col>
            </Row>
          </Col>
        </Row>

        <Table
          loading={consolidatedLoading}
          rowKey={record => record._id}
          rowSelection={rowSelection}
          columns={columnsInvoice}
          dataSource={otaFilteredData}
          onChange={(pagination, filters) => {
            setConsolidatedFilters(filters || {});
          }}
          // scroll={{ x: true }}
        />

        {props.user.isAdmin || props.user.roles[0].permissions.includes(83) ? (
          <Row type="flex" justify="end" style={{ marginTop: 8 }}>
            <Button
              size="large"
              type="primary"
              disabled={
                consolidatedLoading ||
                selectRow.length === 0 ||
                props.selectCompanyProfile.order.subscriptionStatus === 'past_due' ||
                props.selectCompanyProfile.order.subscriptionStatus === 'canceled'
              }
              onClick={() => {
                // Drop anything outside the active table filters (e.g. Select All while Confirmed-filtered)
                const visibleIds = new Set(otaFilteredData.map(row => String(row._id)));
                const rowsForSummary = applyConsolidatedFilters(selectRow).filter(row => visibleIds.has(String(row._id)));
                if (rowsForSummary.length === 0) {
                  message.warning('No bookings match the current table filters. Adjust filters or selection.');
                  return;
                }
                if (rowsForSummary.length !== selectRow.length) {
                  setSelectRow(rowsForSummary);
                }
                const rangeStart = dateRange && dateRange[0] ? dateRange[0] : moment();
                setTargetMonth(rangeStart.format('MMMM'));
                setTargetYear(rangeStart.year());
                setSummaryVisible(true);
                const peeledTotal = rowsForSummary.reduce((acc, cur) => {
                  const peeled = (cur.amount || 0) - (cur.sst || 0) - (cur.tourismTax || 0);
                  return acc + Math.max(0, peeled);
                }, 0);
                const exclusiveAmount = Number(peeledTotal.toFixed(2));
                const actualSst = Number(rowsForSummary.reduce((acc, cur) => acc + (cur.sst || 0), 0).toFixed(2));
                setSelectTotalAmount(exclusiveAmount);
                setSelectSst(actualSst);
                setSelectTtx(0);
                window.scrollTo(0, 0);
              }}
            >
              Next
            </Button>
          </Row>
        ) : null}
      </Tabs.TabPane>
    </Tabs>
  );

  const LinkProfileInformation = (
    <div>
      <Row type="flex" justify="space-between" align="middle" style={{ marginBottom: 40 }}>
        <Col span={12}>
          <Button
            icon="left"
            type="link"
            onClick={() => {
              props.setSelectCompanyProfile(null);
              const url = new URL(window.location.href);
              url.searchParams.delete('_id');
              window.history.pushState({ path: url.toString() }, '', url.toString());
            }}
            style={{
              fontSize: 24,
              padding: 0
            }}
          >
            Link Company Profile Information
          </Button>
        </Col>

        {props.user.isAdmin || props.user.roles[0].permissions.includes(84) ? (
          <Col span={12} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
            {(props.selectCompanyProfile.order.subscriptionStatus === 'active' && props.selectCompanyProfile.order.cancelAtEndDate === false) ||
            (props.selectCompanyProfile.order.subscriptionStatus === 'trialing' && props.selectCompanyProfile.order.cancelAtEndDate === false) ||
            (props.selectCompanyProfile.order.subscriptionStatus === 'complete' && props.selectCompanyProfile.order.cancelAtEndDate === false) ? (
              <>
                <Button
                  type="primary"
                  onClick={() => {
                    handleManageSubscription();
                  }}
                >
                  Manage Subscription
                </Button>{' '}
                <Button style={{ marginLeft: 8 }} onClick={() => setCancelModalVisible(true)}>
                  Cancel Subscription
                </Button>{' '}
                {/* {props.selectCompanyProfile.plan.toLowerCase().includes('pro') && ( */}
                <Button
                  style={{ marginLeft: 8 }}
                  type="primary"
                  onClick={async () => {
                    try {
                      const result = await loginByAccessToken();
                      if (result.success) {
                        // Open eInvoice dashboard in new window
                        window.open(result.data.dashboardUrl || REACT_APP_E_INVOICE_URL + '/dashboard?access_token=' + result.data.token, '_blank');
                      } else {
                        message.error(result.message || 'Failed to login to e-Invoice Dashboard');
                      }
                    } catch (error) {
                      message.error('An error occurred while trying to login to e-Invoice Dashboard');
                      console.error('eInvoice login error:', error);
                    }
                  }}
                >
                  Login e-Invoice Dashboard
                </Button>
                {/* )} */}
              </>
            ) : (props.selectCompanyProfile.order.subscriptionStatus === 'active' && props.selectCompanyProfile.order.cancelAtEndDate === true) ||
              (props.selectCompanyProfile.order.subscriptionStatus === 'trialing' && props.selectCompanyProfile.order.cancelAtEndDate === true) ||
              (props.selectCompanyProfile.order.subscriptionStatus === 'complete' && props.selectCompanyProfile.order.cancelAtEndDate === true) ? (
              <>
                <Button
                  type="primary"
                  onClick={() => {
                    handleManageSubscription();
                  }}
                >
                  Resume Subscription
                </Button>

                {/* {props.selectCompanyProfile.plan.toLowerCase().includes('pro') && ( */}
                <Button
                  style={{ marginLeft: 8 }}
                  type="primary"
                  onClick={async () => {
                    try {
                      const result = await loginByAccessToken();
                      if (result.success) {
                        // Open eInvoice dashboard in new window
                        window.open(result.data.dashboardUrl || REACT_APP_E_INVOICE_URL + '/dashboard?access_token=' + result.data.token, '_blank');
                      } else {
                        message.error(result.message || 'Failed to login to e-Invoice Dashboard');
                      }
                    } catch (error) {
                      message.error('An error occurred while trying to login to e-Invoice Dashboard');
                      console.error('eInvoice login error:', error);
                    }
                  }}
                >
                  Login e-Invoice Dashboard
                </Button>
                {/* )} */}
              </>
            ) : props.selectCompanyProfile.order.subscriptionStatus === 'past_due' ||
              props.selectCompanyProfile.order.subscriptionStatus === 'canceled' ? (
              <Row type="flex" gutter={16} justify="space-between" align="middle">
                <Col style={{ flex: 2 }}>
                  <Alert showIcon type="error" message="Your subscription has expired. Please resubscribe to continue using the service." />
                </Col>
                <Col style={{ flex: 1 }}>
                  <Button
                    type="primary"
                    onClick={() => {
                      setResubscribeVisible(true);
                    }}
                  >
                    Resubscribe
                  </Button>
                </Col>
              </Row>
            ) : null}
          </Col>
        ) : null}
      </Row>

      {CompanyProfileDetails}
      {eInvoiceTabs}
    </div>
  );

  const summaryPayableAmount = Number(((selectTotalAmount || 0) + (selectSst || 0) + (selectTtx || 0)).toFixed(2));
  const sstHintAmount = Number((Number(selectTotalAmount || 0) * 0.08).toFixed(2));

  const eInvoiceSummary = (
    <div>
      <Button
        icon="left"
        type="link"
        onClick={() => {
          setSelectRow([]);
          setSummaryVisible(false);
        }}
        style={{
          fontSize: 24,
          padding: 0,
          marginBottom: 24
        }}
      >
        Create Consolidated e-Invoice Summary
      </Button>

      <div style={{ marginBottom: 24 }}>
        <Row type="flex" justify="space-between" align="bottom">
          <Col>
            <Alert
              style={{ marginBottom: 16 }}
              showIcon
              type="info"
              message="Please confirm the total number of amount before creating consolidated e-Invoice."
            />
            <Row style={{ fontSize: 20, marginBottom: 16 }}>
              Total number of booking: <span style={{ fontWeight: 'bold' }}>{selectRow.length}</span>
            </Row>

            <Row style={{ fontSize: 20 }}>
              <span style={{ marginRight: 8 }}>Amount (RM):</span>
              <InputNumber
                min={0}
                precision={2}
                style={{ fontSize: 20, width: 150 }}
                value={selectTotalAmount}
                onChange={value => {
                  setSelectTotalAmount(value != null ? value : 0);
                }}
              />
            </Row>

            <Row style={{ fontSize: 20, marginTop: 16 }} type="flex" align="middle">
              <span style={{ marginRight: 8 }}>SST (RM):</span>
              <InputNumber
                min={0}
                precision={2}
                style={{ fontSize: 20, width: 150, marginRight: 8 }}
                value={selectSst}
                onChange={value => {
                  setSelectSst(value != null ? value : 0);
                }}
              />
              <Button
                type="primary"
                onClick={() => {
                  setSelectSst(Number((Number(selectTotalAmount || 0) * 0.08).toFixed(2)));
                }}
              >
                Auto calculate
              </Button>
            </Row>
            <div style={{ fontSize: 12, color: 'rgba(0, 0, 0, 0.45)', marginTop: 4 }}>
              SST = Amount × 8% ({Number(selectTotalAmount || 0).toFixed(2)} × 8% = {sstHintAmount.toFixed(2)})
            </div>

            <Row style={{ fontSize: 20, marginTop: 16 }}>
              <span style={{ marginRight: 8 }}>TTX (RM):</span>
              <InputNumber
                min={0}
                precision={2}
                style={{ fontSize: 20, width: 150 }}
                value={selectTtx}
                onChange={value => {
                  setSelectTtx(value != null ? value : 0);
                }}
              />
            </Row>

            <Row style={{ fontSize: 20, marginTop: 16 }}>
              <span style={{ marginRight: 8 }}>Total (RM):</span>
              <span style={{ fontWeight: 'bold' }}>{generateDisplayFee(summaryPayableAmount)}</span>
            </Row>

            <Row style={{ fontSize: 20, marginTop: 16 }} type="flex" align="middle">
              <span style={{ marginRight: 8 }}>Target Month:</span>
              <Select
                style={{ width: 140, fontSize: 16, marginRight: 8 }}
                value={targetMonth}
                onChange={value => setTargetMonth(value)}
                placeholder="Month"
              >
                {monthOptions.map(month => (
                  <Select.Option key={month} value={month}>
                    {month}
                  </Select.Option>
                ))}
              </Select>
              <Select style={{ width: 100, fontSize: 16 }} value={targetYear} onChange={value => setTargetYear(value)} placeholder="Year">
                {yearOptions.map(year => (
                  <Select.Option key={year} value={year}>
                    {year}
                  </Select.Option>
                ))}
              </Select>
            </Row>
          </Col>

          <Col>
            <Button
              size="large"
              type="primary"
              disabled={!targetMonth || !targetYear}
              onClick={() => {
                Modal.confirm({
                  title: 'Create Consolidated e-Invoice',
                  content: (
                    <>
                      <div>Are you sure you want to create consolidated e-Invoice?</div>
                      <br />
                      <Row type="flex" gutter={8}>
                        <Col>Total number of booking:</Col>
                        <Col>{selectRow.length}</Col>
                      </Row>
                      <Row type="flex" gutter={8}>
                        <Col>Amount:</Col>
                        <Col>{generateDisplayFee(selectTotalAmount)}</Col>
                      </Row>
                      <Row type="flex" gutter={8}>
                        <Col>SST:</Col>
                        <Col>{generateDisplayFee(selectSst)}</Col>
                      </Row>
                      <Row type="flex" gutter={8}>
                        <Col>TTX:</Col>
                        <Col>{generateDisplayFee(selectTtx)}</Col>
                      </Row>
                      <Row type="flex" gutter={8}>
                        <Col>Total:</Col>
                        <Col>{generateDisplayFee(summaryPayableAmount)}</Col>
                      </Row>
                      <Row type="flex" gutter={8}>
                        <Col>Target month:</Col>
                        <Col>
                          {targetMonth} {targetYear}
                        </Col>
                      </Row>
                    </>
                  ),
                  onOk() {
                    handleCreateConsolidatedInvoice();
                  }
                });
              }}
            >
              Create Consolidated e-Invoice
            </Button>
          </Col>
        </Row>
      </div>

      <Table
        loading={loading}
        rowKey={record => record._id}
        columns={columnsInvoice}
        dataSource={selectRow}
        // scroll={{ x: true }}
      />
    </div>
  );

  return (
    <div>
      {!summaryVisible ? LinkProfileInformation : eInvoiceSummary}
      <Drawer
        title={bookingsDrawerInvoice ? `Reservations — ${bookingsDrawerInvoice.documentNo}` : 'Reservations'}
        visible={bookingsDrawerVisible}
        onClose={() => {
          setBookingsDrawerVisible(false);
          setBookingsDrawerInvoice(null);
          setBookingsData([]);
        }}
        width={1100}
        destroyOnClose
      >
        <Row type="flex" justify="space-between" align="middle" style={{ marginBottom: 16 }}>
          <Col>
            <div>
              Total reservations: <strong>{bookingsTotal}</strong>
            </div>
            <div>
              Invoice amount: <strong>{generateDisplayFee(bookingsTotalAmount)}</strong>
            </div>
          </Col>
          <Col>
            <Button type="primary" icon="cloud-download" loading={bookingsCsvLoading} onClick={handleDownloadBookingsCsv}>
              Export CSV
            </Button>
          </Col>
        </Row>
        <Table
          loading={bookingsLoading}
          rowKey={record => record.reservationId || record.bookingId || record._id}
          columns={columnsInvoice}
          dataSource={bookingsData}
          scroll={{ x: true }}
          pagination={{
            current: bookingsPage,
            pageSize: 50,
            total: bookingsTotal,
            showTotal: total => `${total} reservations`
          }}
          onChange={pagination => {
            if (bookingsDrawerInvoice && pagination.current !== bookingsPage) {
              GetInvoiceBookings(bookingsDrawerInvoice, pagination.current);
            }
          }}
        />
      </Drawer>
      <ResubscribeModal visible={resubscribeVisible} onCancel={() => setResubscribeVisible(false)} id={props.selectCompanyProfile._id} />
      <Modal
        title="Cancel subscription?"
        visible={cancelModalVisible}
        onCancel={() => setCancelModalVisible(false)}
        confirmLoading={loading}
        footer={[
          <Button key="keep" onClick={() => setCancelModalVisible(false)}>
            Keep subscription
          </Button>,
          <Button key="cancel" type="danger" ghost loading={loading} onClick={handleCancelSubscription}>
            Cancel at period end
          </Button>
        ]}
      >
        <div style={{ marginBottom: 12 }}>
          <div>
            <strong>Company:</strong> {props.selectCompanyProfile.name}
          </div>
          <div>
            <strong>Plan:</strong> {props.selectCompanyProfile.plan}
          </div>
          <div>
            <strong>Next charge date:</strong> {formatOrderRenewalLabel(props.selectCompanyProfile.order.endDate)}
          </div>
          <div>
            <strong>Next charge amount:</strong> {nextChargeAmount}
          </div>
        </div>
        <div
          style={{
            padding: '12px 14px',
            background: '#fff7e6',
            borderLeft: '3px solid #faad14',
            borderRadius: 4,
            fontSize: 13,
            lineHeight: 1.5
          }}
        >
          If you cancel now, you keep access until <strong>{formatOrderRenewalLabel(props.selectCompanyProfile.order.endDate)}</strong>. You will not
          be charged again after that date. Cancelling today does not stop a charge that already started for this period.
        </div>
      </Modal>
    </div>
  );
};

export default withAppContext(CompanyProfile);
